export class AccountLogTypeModel {
    logType;
    hasSampleLogs;
    pipelineEditor;
    supportedLogType;
    get value() {
        return this.logType;
    }
    get name() {
        return this.logType;
    }
}
//# sourceMappingURL=accounts-log-type.js.map